import styled, { css } from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as ButtonSlider from "../../../../../../../common-deprecated/features/filters/components/lexus/filters/ButtonSlider/styles/ButtonSliderStyles";
import * as FilterDescription from "../../../../../../../common-deprecated/features/filters/components/lexus/filters/FilterDescription/styles/FilterDescriptionStyles";

const commonFilterdescriptionStyles = css`
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    line-height: 1.3rem;
    color: ${theme.colors.white};
    word-break: break-word;
    hyphens: auto;
`;

export const Wrapper = styled(Flex.Row)`
    /* Overrides for filter description (Filter description is still shared with tridion components) */
    ${FilterDescription.Min} {
        ${commonFilterdescriptionStyles};
    }
    ${FilterDescription.Max} {
        ${commonFilterdescriptionStyles};
    }
    ${FilterDescription.Title} {
        ${commonFilterdescriptionStyles};
    }
    ${FilterDescription.Subtitle} {
        ${commonFilterdescriptionStyles};
    }

    /* Overrides ButtonSliderStyles (ButtonSlider is still shared with tridion components) */
    ${ButtonSlider.Value} {
        font-family: ${theme.fonts.book};
        font-size: 2.2rem;
        line-height: 2.6rem;
        color: ${theme.colors.white};
    }
`;

export const Result = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${theme.space[4]}px ${theme.space[2]}px 0;
`;

export const Label = styled.div.attrs(() => ({
    className: "l-zeta-text",
}))`
    color: ${theme.colors.white};
`;

export const Value = styled.div.attrs(() => ({
    className: "l-gamma-text",
}))<{ hasLongText?: boolean }>`
    max-width: 100%;
    font-size: ${({ hasLongText }) => (hasLongText ? 1.4 : 1.8)}rem;
    text-align: center;
    text-overflow: ellipsis;
    color: ${theme.colors.white};
    white-space: nowrap;
    overflow: hidden;
`;
